import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryItem } from '../../EventRegistryItem';
export class EventRegistryReactComposition extends EventRegistryCategory {
    label = 'Composition Events';
    constructor(parent) {
        super(parent);
        super.init();
    }
    compositionstart = () => new EventRegistryItem({ handlerName: 'onCompositionEnd' });
    compositionupdate = () => new EventRegistryItem({ handlerName: 'onCompositionUpdate' });
    compositionend = () => new EventRegistryItem({ handlerName: 'onCompositionEnd' });
}
